import { ThemeColors } from './types';
import { FIELPET_DEFAULT_COLORS } from './themes';

const HEX_COLOR_REGEX = /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/;

const isValidHex = (color: string): boolean => HEX_COLOR_REGEX.test(color);

const safeColor = (color: string | undefined, fallback: string): string => {
  if (!color) return fallback;
  return isValidHex(color) ? color : fallback;
};

const hexToRgb = (hex: string): string => {
  const normalized = hex.replace('#', '');
  const fullHex = normalized.length === 3
    ? normalized.split('').map((char) => `${char}${char}`).join('')
    : normalized;
  const value = Number.parseInt(fullHex, 16);

  return [
    (value >> 16) & 255,
    (value >> 8) & 255,
    value & 255,
  ].join(', ');
};

export const applyTheme = (colors: ThemeColors) => {
  const root = document.documentElement;
  const primary = safeColor(colors.primary, FIELPET_DEFAULT_COLORS.primary);
  const secondary = safeColor(colors.secondary, FIELPET_DEFAULT_COLORS.secondary);

  root.style.setProperty('--ion-color-primary', primary);
  root.style.setProperty('--ion-color-primary-rgb', hexToRgb(primary));
  root.style.setProperty('--ion-color-secondary', secondary);
  root.style.setProperty('--ion-color-secondary-rgb', hexToRgb(secondary));
  root.style.setProperty(
    '--ion-color-gray',
    safeColor(colors.gray, FIELPET_DEFAULT_COLORS.gray),
  );
  root.style.setProperty(
    '--ion-color-gray_light',
    safeColor(colors.gray_light, FIELPET_DEFAULT_COLORS.gray_light),
  );
  root.style.setProperty(
    '--ion-color-icon',
    safeColor(colors.icon, FIELPET_DEFAULT_COLORS.icon),
  );
  root.style.setProperty(
    '--ion-color-icon_bg',
    safeColor(colors.icon_bg, FIELPET_DEFAULT_COLORS.icon_bg),
  );
  root.style.setProperty(
    '--ion-color-bg_light',
    safeColor(colors.bg_light, FIELPET_DEFAULT_COLORS.bg_light),
  );
};

// Barrel exports
export { THEME_CONFIG, DEFAULT_THEME, isDynamicThemeEnabled } from './config';
export { ThemeProvider, useTheme } from './ThemeContext';
export { THEMES, getTheme, FIELPET_DEFAULT_COLORS } from './themes';
export type { ThemeColors, ThemeName, DynamicTheme } from './types';
